import * as Yup from 'yup';

export const LoginValidationSchema = Yup.object().shape({
	username: Yup.string()
		.email('Adresse e-mail invalide')
		.required('Veuillez entrer une adresse e-mail'),
	password: Yup.string().required('Veuillez entrer un mot de passe'),
})